export class ImgUrlUtils {

    static src(url: string | null, width: number): string {

        if (!url) {
            return "";
        }
        
        try {
            const urlObj = new URL(url);
            urlObj.searchParams.set("width", `${width}`);
            return urlObj.toString();
        } catch (e) {
            return "";
        }
    }

    static srcset(url: string | null, width: number): string {
        if (!url) {
            return "";
        }

        return `${this.src(url, width * 2)} 2x, ${this.src(url, width)} 1x`;
    }

    super() {
        return this;
    }
}
